import axios from "axios"
import qs from "qs"

type GetCheckoutSessionRequest = {
  userId: number
  courseId: number
  returnPath: string
}

type GetCheckoutSessionResponse = {
  url: string
}

type GetExternalCertificateCheckoutSessionRequest = {
  userId: number
  superCourseId: number
  returnPath: string
}

type GetExternalCertificateCheckoutSessionResponse = {
  url: string
}

export const STRIPE_KEYS = {
  GET_CHECKOUT_SESSION: "getCheckoutSession",
  GET_EXTERNAL_CERTIFICATE_CHECKOUT_SESSION: "getExternalCertificateCheckoutSession",
}

export const getCheckoutSession = async ({ userId, courseId, returnPath }: GetCheckoutSessionRequest) => {
  const params = qs.stringify(
    {
      user: userId,
      course: courseId,
      returnPath,
    },
    { encodeValuesOnly: true }
  )

  const url = `/create-stripe-checkout-session?${params}`

  const response = await axios.get<GetCheckoutSessionResponse>(url)

  return response.data
}

export const getExternalCertificateCheckoutSession = async ({
  userId,
  superCourseId,
  returnPath,
}: GetExternalCertificateCheckoutSessionRequest) => {
  const params = qs.stringify(
    {
      userId,
      superCourseId,
      returnPath,
    },
    { encodeValuesOnly: true }
  )

  const url = `/create-external-certificate-checkout-session?${params}`

  const response = await axios.get<GetExternalCertificateCheckoutSessionResponse>(url)

  return response.data
}
